import type { TextFieldProps } from '@mui/material';
import { TextField as MuiTextField } from '@mui/material';
import type { FC } from 'react';

import { ExclamationPointIcon } from 'assets/svg';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

export const TeamingAdhocRequestTextField: FC<TextFieldProps> = (props) => {
  return (
    <TextField
      {...props}
      type='text'
      variant='outlined'
      InputProps={{
        endAdornment: props.error && <ExclamationPointIcon />,
      }}
    />
  );
};

//TODO Update TextField UI component to avoid custom styles in different places when Doug will present design
const TextField = styled(MuiTextField)`
  .MuiInputBase-input {
    padding: ${theme.spacing(4, 6)};
  }
  .MuiInputBase-root {
    border: 1px solid ${theme.palette.grey[300]};
    border-radius: 8px;
    background-color: transparent;
    &.Mui-error {
      border-color: ${theme.palette.error.contrastText};
    }
  }

  .MuiFormHelperText-root {
    margin: ${theme.spacing(3, 0, 0)};
    &.Mui-error {
      color: ${theme.palette.error.contrastText};
    }
  }
`;
